import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { logoutUser } from "../store/userSlice";
import { Bounce, toast } from "react-toastify";
import { logoutService } from "../Service/UserService"; // Assuming logout API call

const Logout = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  useEffect(() => {
    const handleLogOut = async () => {
      try {
        const token = Cookies.get("access_token");
        
        if (!token) {
          toast.error("No token found. You are already logged out.", {
            position: "top-right",
            autoClose: 1200,
            theme: "dark",
            transition: Bounce,
          });
          alert("Logout component is rendered");
          return navigate("/login");
        }

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };

        const response = await logoutUser(config);

        if (response.message === "Logout successful") {
          toast.success("Logged out successfully!", {
            position: "top-right",
            autoClose: 1200,
            theme: "dark", // Green success toast
            transition: Bounce,
          });

          // Remove cookies
          Cookies.remove("access_token");
          Cookies.remove("user");

          // Dispatch Redux action
          // dispatch(logoutUser());

          // Redirect to login
          navigate("/login");
        }
      } catch (error) {
        console.error("Error during logout:", error);
        toast.error("Logout failed. Please try again.", {
          position: "top-right",
          autoClose: 1200,
          theme: "dark",
          transition: Bounce,
        });
      }
    };

    handleLogOut();
  }, []);

  // return null;
};

export default Logout;
